import React from 'react';
import './Cali.css'; 

const Carepa = () => {
  return (
   <div>
    <div className='Espacio-titulo'>
    <h1><a className='Titulo' href="/aip/SKLC.pdf" target="_blank" rel="noreferrer">Aeropuerto Antonio Roldán Betancourt</a></h1>
    </div>
    <div className='containeraeropuertos'>
      
      <div className='subcontaineraeropuertos'>
        <h1>SID</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 15</th>                      
          </tr>  
          
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLC/MAPS2D.pdf" target="_blank" rel="noreferrer">MAPS2D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLC/MAPS2D.pdf" target="_blank" rel="noreferrer">REMU1H</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLC/BOKU1K.pdf" target="_blank" rel="noreferrer">BOKU1K</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLC/BOKU1K.pdf" target="_blank" rel="noreferrer">ISRA1J</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLC/BOKU1K.pdf" target="_blank" rel="noreferrer">KAKO1D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLC/BOKU1K.pdf" target="_blank" rel="noreferrer">KUBE1D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLC/ISRA1F.pdf" target="_blank" rel="noreferrer">ISRA1F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLC/ISRA1F.pdf" target="_blank" rel="noreferrer">REMU1D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLC/ISRA1F.pdf" target="_blank" rel="noreferrer">REMU1E</a></th>
          </tr>


          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 33</th>                      
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKLC/LCE1A.pdf" target="_blank" rel="noreferrer">LCE1A</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKLC/BOKU1A.pdf" target="_blank" rel="noreferrer">BOKU1A</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKLC/BOKU1A.pdf" target="_blank" rel="noreferrer">ISRA1H</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKLC/BOKU1A.pdf" target="_blank" rel="noreferrer">KAKO1C</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKLC/BOKU1A.pdf" target="_blank" rel="noreferrer">MAPS2C</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKLC/BOKU1A.pdf" target="_blank" rel="noreferrer">REMU1G</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKLC/KUBE1C.pdf" target="_blank" rel="noreferrer">KUBE1C</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKLC/KAKO1A.pdf" target="_blank" rel="noreferrer">KAKO1A</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKLC/KAKO1A.pdf" target="_blank" rel="noreferrer">KUBE1A</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKLC/BOKU1H.pdf" target="_blank" rel="noreferrer">BOKU1H</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKLC/BOKU1H.pdf" target="_blank" rel="noreferrer">MAPS1A</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKLC/BOKU1H.pdf" target="_blank" rel="noreferrer">REMU1B</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKLC/ISRA2E.pdf" target="_blank" rel="noreferrer">ISRA2E</a></th>
          </tr>
          <tr>
          <th className='Procedimientos'><a href="/regionales/SKLC/ISRA2E.pdf" target="_blank" rel="noreferrer">REMU2C</a></th>
          </tr>
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>STAR</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 15</th>                      
          </tr>
                   
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 33</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLC/REMU2A.pdf" target="_blank" rel="noreferrer">REMU2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLC/BOKU1J.pdf" target="_blank" rel="noreferrer">BOKU1J</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLC/BOKU1J.pdf" target="_blank" rel="noreferrer">ISRA1G</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLC/BOKU1J.pdf" target="_blank" rel="noreferrer">MAPS2B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLC/BOKU1J.pdf" target="_blank" rel="noreferrer">REMU1F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLC/KAKO1B.pdf" target="_blank" rel="noreferrer">KAKO1B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLC/KAKO1B.pdf" target="_blank" rel="noreferrer">KUBE1B</a></th>
          </tr>

          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>IAC</h1>
        <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 15</th>                      
          </tr>          
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 33</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLC/VOR33.pdf" target="_blank" rel="noreferrer">VOR</a></th>
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKLC/RNP33.pdf" target="_blank" rel="noreferrer">RNP</a></th>
          </tr>
          </table>
        </div>
      </div>

    </div>

  </div>
  );
};
export default Carepa;